module.exports = __webpack_public_path__ + "img/sys_1.aec2f7e6.png";